export default __webpack_public_path__ + "static/media/login.e5d67f7d.svg";